<template>
  <div class="onLineShopContainer">
    <div class="shopHead">
      <div class="shopType">
        <div
          v-for="(item, index) in productTypeList"
          :key="index"
          class="shopTypeItem"
        >
          <div class="shopTypeTitle">{{ item.name }}</div>
          <div class="shopChildTypeList">
            <span
              v-for="(childType, j) in item.children"
              :key="j"
              class="childType"
              @click="goList(childType.id)"
              >{{ childType.name }}</span
            >
          </div>
        </div>
      </div>
      <div class="shopCarousel">
        <el-carousel height="500px">
          <el-carousel-item
            v-for="(item, index) in shopCarouselList"
            :key="index"
          >
            <img :src="item.coverImg" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="shopOutContent">
      <div class="shopOutContentTitle">
        <div class="outTitle">供应信息</div>
        <span @click="goList('')">更多></span>
      </div>
      <div class="shopOutContentList">
        <div
          v-for="(item, index) in productsInfoList"
          :key="index"
          class="shopOutProduct"
          @click="goDetail(item.id)"
        >
          <div class="shopOutImg">
            <img
              :src="
                item.imgs.indexOf(',') >= 0
                  ? item.imgs.split(',')[0]
                  : item.imgs
              "
              alt="图片加载失败"
            />
          </div>
          <div class="shopOutText">
            <div class="shopOutTextPrice">
              <span class="price">{{ Number(item.price).toFixed(2) }}</span>
              <span class="category">{{ item.category }}</span>
            </div>
            <span class="name" :title="item.name">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="shopPage">
        <el-pagination
          layout="prev, pager, next, total"
          :total="xiangmuTotal"
          @prev-click="prevClick"
          @next-click="nextClick"
          :page-size="productsInfoPageSize"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProductTypeList,
  getProductsInfoList,
  getProductsInfo,
  getPurchaserProductsList,
  getPurchaserProductsInfo
} from "../api/在线商城"
import { getNewslist } from '../api/mian'
export default {
  data () {
    return {
      // 农产品分类列表
      productTypeList: [],
      // 农产品详情列表
      productsInfoList: [],
      // 农产品详情列表
      productsInfoPageSize: 12,
      productsInfoPageNum: 1,
      // 农产品详情总数
      xiangmuTotal: 0,
      // 农产品详情信息
      productsInfo: [],
      // 农产品需求列表
      purchaserProductsList: [],
      // 农产品需求详细信息
      purchaserProducts: [],
      // 轮播新闻列表
      shopCarouselList: [],
    }
  },
  mounted () {
    getProductTypeList().then(res => {
      this.productTypeList = res.data.data
    })
    getNewslist({
      number: '031001',
      pageSize: 4,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      this.shopCarouselList = res.data.rows
    })
    this.getList()
  },
  methods: {
    goDetail (id) {
      this.$router.push({
        path: '/onLineShopDetail',
        query: {
          id,
        }
      })
    },
    currentChange (e) {
      this.productsInfoPageNum = e
      this.getList()
    },
    prevClick () {
      this.productsInfoPageNum--
      this.getList()
    },
    nextClick () {
      this.productsInfoPageNum++
      this.getList()
    },
    getList () {
      getProductsInfoList({
        pageSize: this.productsInfoPageSize,
        pageNum: this.productsInfoPageNum,
      }).then(res => {
        this.productsInfoList = res.data.rows
        this.xiangmuTotal = res.data.total
      })
    },
    // 跳转在线商城列表页
    goList (type = "") {
      console.log("type", type)
      if (type != "") {
        this.$router.push({
          path: '/onLineShopList',
          query: { shopTypeId: type }
        })
      } else {
        this.$router.push({
          path: '/onLineShopList',
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
*,
html,
body {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.onLineShopContainer {
  width: 1824px;
  margin: 0 auto;
  min-height: 810px;
  background-color: #fff;
  padding: 30px 0;
  .shopHead {
    display: flex;
    flex-flow: row nowrap;
    height: 500px;
    width: 100%;
    align-items: center;
    .shopType {
      width: 400px;
      height: 100%;
      max-height: 100%;
      overflow: auto;
      display: flex;
      flex-flow: column nowrap;
      margin-right: 20px;
      background-color: #fff;
      box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
      padding: 20px 30px;
      .shopTypeItem {
        margin-top: 10px;
        .shopTypeTitle {
          font-size: 22px;
          font-weight: 550;
          margin-bottom: 10px;
        }
        .shopChildTypeList {
          display: flex;
          flex-flow: row wrap;
          width: 100%;
          .childType {
            margin-right: 10px;
            cursor: pointer;
            font-size: 18px;
          }
        }
      }
    }
    .shopCarousel {
      flex: 1;
      height: 100%;
      img {
        display: block;
        height: 100%;
        width: 100%;
      }
    }
  }
  .shopOutContent {
    margin-top: 30px;
    height: auto;
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    .shopOutContentTitle {
      border-bottom: 1px solid #2187ff;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      //padding: 0 61px 0 37px;
      height: 80px;
      .outTitle {
        display: block;
        width: auto;
        height: 50px;
        font-size: 37px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2187ff;
        padding-left: 5px;
        border-left: #2187ff 6px solid;
      }
      span {
        display: block;
        width: auto;
        height: 80px;
        font-size: 25px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2187ff;
        line-height: 80px;
        cursor: pointer;
      }
    }
    .shopOutContentList {
      width: 100%;
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      grid-column-gap: 30px;
      padding: 30px 0;
      min-height: 360px;
      .shopOutProduct {
        height: 360px;
        width: 100%;
        box-shadow: 0px 0px 12px 0px rgba(21, 21, 21, 0.1);
        display: flex;
        flex-flow: column nowrap;
        cursor: pointer;
        margin-bottom: 30px;
        transition: all 0.3s;
        &:hover {
          box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.2);
        }
        .shopOutImg {
          height: 200px;
          width: 100%;
          img {
            height: 100%;
            width: 100%;
          }
        }
        .shopOutText {
          display: flex;
          flex-flow: column nowrap;
          justify-content: center;
          flex: 1;
          padding: 28px;
          width: 100%;
          .shopOutTextPrice {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            width: 100%;
            height: auto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 6px;
            .price {
              font-size: 24px;
              color: #f00;
              font-weight: 700;
              margin-right: 4px;
            }
            .category {
              color: #f00;
            }
          }
          .name {
            width: 223px;
            height: auto;
            font-size: 18px;
            color: rgb(96, 98, 102);
            max-lines: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .shopPage {
      display: flex;
      flex-flow: row nowrap;
      width: 100%;
      justify-content: end;
    }
  }
}
</style>